<template>
    <div class="wb-tooltips-button-anchor" :style="{'right': '22px', 'bottom': '20px'}">
        <div class="wb-tooltips-button" v-on:click="storeUI.switchIsTooltip()">
            <div class="wb-tooltips-button-inner">
                ?
            </div>
        </div>
    </div>
</template>

<script>
import { useUIOnlyStore } from '@/Store/storeUI';

export default {
    name: 'OverlayTooltipsButton',
    setup() {
        const storeUI = useUIOnlyStore();
        return {
            storeUI,
        };
    },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/fonts.scss";
@import "CSS/common.scss";
@import "CSS/animations.scss";

.wb-tooltips-button-anchor {
    display: flex;
    align-items: end;
    justify-content: end;
    height: 0;
    width: 0;
    position: absolute;
    z-index: 100;
}

.wb-tooltips-button {
    @include wb-c-flex-center;
    width: 48px;
    height: 48px;
    border-radius: 24px;
    background-color: $white;
    flex-grow: 0;
    flex-shrink: 0;
    cursor: pointer;
    user-select: none;
}

.wb-tooltips-button-inner {
    @include font-h1-2b;
    @include wb-c-flex-center;
    @include button-smooth;
    color: $white;
    background-color: $darkBlue;
    width: 20px;
    height: 20px;
    border-radius: 10px;
}

.wb-tooltips-button:hover .wb-tooltips-button-inner {
    background-color: $darkBlue80;
}

.wb-tooltips-button:active .wb-tooltips-button-inner {
    background-color: $green1;
}

</style>
